import styles from './no-javascript.module.scss'

export default function NoJavascript() {
  return (
    <p className={styles["no-javascript"]}>
      This page requires javascript to function properly. Please enable it and try again.
    </p>
  )
}
